// This component acts as a rollup for our modal css that themes semantics modal, while also leaving the option to import
// Modal.Header, Modal.Content, etc.
// This is strictly a passthrough component for semantic where we can append on any css to their modal while keeping the two relatively close to each other
import { Modal } from "semantic-ui-react";
import "../../styles/Modal.module.scss";
export default Modal;
